import React from "react"
import PropTypes from "prop-types"
import missingIllustration from "@/public/images/image-missing.png"

const ImageSection = props => {
  const { product, varentList } = props
  const imageInfo = varentList.length !== 0 ? varentList : product
  return (
    <div className="product-split-container">
      <div id="standard-image-container" className="standard-image-container">
        <ProductImage item={imageInfo} />
      </div>
    </div>
  )
}
ImageSection.propTypes = {
  product: PropTypes.object.isRequired,
  varentList: PropTypes.array.isRequired,
}

export default React.memo(ImageSection)

const ProductImage = ({ item }) => {
  return (
    <>
      {item?.imageUrl ? (
        <div
          className={`standard-product-image position-relative image_${item?.sku}`}
          id={item?.sku}
        >
          <img
            src={item?.imageUrl}
            alt="Standard Product"
            onError={e => {
              e.target.src = missingIllustration.src
              e.target.parentNode.classList.add("missing")
            }}
          />
        </div>
      ) : (
        <div className="standard-product-image missing">
          <img src={missingIllustration.src} alt="Standard Product" />
        </div>
      )}
    </>
  )
}

ProductImage.propTypes = {
  item: PropTypes.shape({
    imageUrl: PropTypes.string,
  }).isRequired,
}
